// ============ بيانات الشركة: مصدر واحد للموقع كله (النافبار، الفوتر، التواصل، الـ SEO) ============
// أي تعديل في التليفون أو الإيميل أو العنوان أو المواعيد يتعمل هنا بس.

// الدومين الأساسي (من غير / في الآخر). لو هتستخدم www غيّرها لـ https://www.helmaxrealestate.com
export const SITE_URL = "https://helmaxrealestate.com";

export const COMPANY = {
  name: "HELMAX Real Estate",
  shortName: "HELMAX",

  phone: "+971566005800", // للاتصال (من غير مسافات)
  phoneLabel: "+971 56 600 5800", // للعرض
  whatsapp: "971566005800", // من غير + ولا مسافات

  email: "info@helmaxrealestate.com",

  // العنوان كما هو على جوجل ماب
  address: {
    office: "Office 1141",
    building: "Tamani Arts Offices",
    street: "Al Asayel St",
    area: "Business Bay",
    city: "Dubai",
    country: "AE",
    countryName: "United Arab Emirates",
  },

  // إحداثيات المكتب من جوجل ماب
  geo: { lat: 25.1874816, lng: 55.2806825 },

  // لينك جوجل ماب اللي بعته + اللينك الدائم بتاع النشاط التجاري (CID)
  mapShareUrl: "https://maps.app.goo.gl/qgZWq7qYakETrH7k9",
  mapUrl: "https://www.google.com/maps?cid=11311285576802649409",
  placeId: "ChIJiX0KOXFpXz4RQUVSZk3C-Zw",

  // مواعيد العمل: الاثنين للسبت من 12 الظهر لـ 10 بالليل (الأحد إجازة)
  hours: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "12:00",
    closes: "22:00",
  },

  socials: [
    { id: "facebook", label: "Facebook", href: "https://www.facebook.com/share/1JirzjtDC8/" },
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/helmax_realestate" },
    { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@helmaxuae" },
  ],

  logo: "/logo512.png", // حط لوجو الشركة في public/logo512.png (مربع 512×512)
  ogImage: "/og-image.jpg", // صورة المشاركة على السوشيال (1200×630)
};

export const whatsappUrl = (text) =>
  `https://wa.me/${COMPANY.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

// خريطة جوجل جوه الصفحة (من غير API key) باللغة المختارة
export const mapEmbedUrl = (lang = "en") =>
  `https://maps.google.com/maps?q=${encodeURIComponent(
    `${COMPANY.name}, ${COMPANY.address.building}, ${COMPANY.address.area}, Dubai`
  )}&ll=${COMPANY.geo.lat},${COMPANY.geo.lng}&z=17&hl=${lang}&output=embed`;

// العنوان كسطر واحد (للـ SEO والـ llms.txt)
export const addressLine = () => {
  const a = COMPANY.address;
  return `${a.office}, ${a.building}, ${a.street}, ${a.area}, ${a.city}, ${a.countryName}`;
};
